export const queryKeys = {
  auth: {
    sessions: ['auth', 'sessions'] as const,
  },
  users: {
    all: ['users'] as const,
    list: (params: Record<string, unknown>) => ['users', 'list', params] as const,
    detail: (id: string) => ['users', id] as const,
    activity: (id: string) => ['users', id, 'activity'] as const,
  },
  organizations: {
    all: ['organizations'] as const,
    list: (params: Record<string, unknown>) => ['organizations', 'list', params] as const,
    detail: (id: string) => ['organizations', id] as const,
  },
  subscriptions: {
    all: ['subscriptions'] as const,
    list: (params: Record<string, unknown>) => ['subscriptions', 'list', params] as const,
    detail: (id: string) => ['subscriptions', id] as const,
  },
  invoices: {
    all: ['invoices'] as const,
    list: (params: Record<string, unknown>) => ['invoices', 'list', params] as const,
    detail: (id: string) => ['invoices', id] as const,
  },
  support: {
    tickets: {
      all: ['tickets'] as const,
      list: (params: Record<string, unknown>) => ['tickets', 'list', params] as const,
      detail: (id: string) => ['tickets', id] as const,
    },
    templates: {
      all: ['email-templates'] as const,
      detail: (id: string) => ['email-templates', id] as const,
    },
  },
  analytics: {
    dashboard: ['analytics', 'dashboard'] as const,
    revenue: (days: number) => ['analytics', 'revenue', days] as const,
    users: (days: number) => ['analytics', 'users', days] as const,
    processing: (days: number) => ['analytics', 'processing', days] as const,
    timeseries: (metric: string, days: number) => ['analytics', 'timeseries', metric, days] as const,
  },
  system: {
    featureFlags: ['system', 'feature-flags'] as const,
    auditLogs: (params: Record<string, unknown>) => ['system', 'audit-logs', params] as const,
    auditLogDetail: (id: string) => ['system', 'audit-logs', id] as const,
    health: ['system', 'health'] as const,
    metrics: ['system', 'metrics'] as const,
  },
  adminUsers: {
    all: ['admin-users'] as const,
    list: (params: Record<string, unknown>) => ['admin-users', 'list', params] as const,
    detail: (id: string) => ['admin-users', id] as const,
  },
};
